import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import { h2 } from '@helpers/typography';
import MotionTrack from '@stories/Components/Misc/Carousels/Carousel/MotionTrack/MotionTrack';
import PaginationStyles from '@stories/Components/Misc/Carousels/Carousel/Pagination/Pagination.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --bgColour: ${brand.global.white};
  --fgColour: ${brand.global.black};

  background-color: var(--bgColour);
  color: var(--fgColour);
  overflow: hidden;

  @media ${from(Device.Desktop)} {
    ${SectionWrapperStyles.Inner} {
      display: grid;
      grid-template-columns: auto 1fr;
    }
  }

  ${PaginationStyles.Container} {
    margin: 32px 0 0;

    @media ${from(Device.Desktop)} {
      margin: 0 0 32px;
      grid-row: 1;
      grid-column: 2 / span 1;
    }
  }
`;
const Title = styled.h2 `
  ${h2};

  margin: 0 0 32px;
`;
const CarouselWrapper = styled.div `
  --itemPeek: 100px;
  --itemGutter: ${fluid(20, 40)};
  --visibleItems: 1;

  margin: 0 calc(var(--itemGutter) * -0.5);

  @media ${from(Device.MobileLarge)} {
    --itemPeek: 50px;
  }

  @media ${from(Device.TabletSmall)} {
    --visibleItems: 2;
  }

  @media ${from(Device.TabletLarge)} {
    --visibleItems: 3;
  }

  @media ${from(Device.Desktop)} {
    --itemPeek: 0px;
    --visibleItems: 4;

    grid-row: 2;
    grid-column: 1 / span 2;
  }
`;
const Track = styled(MotionTrack) ``;
const Item = styled.li `
  display: block;
  flex: 0 0 calc(100% / var(--visibleItems) - (var(--itemPeek, 0px) / var(--visibleItems)));
  padding: 0 calc(var(--itemGutter) / 2);
`;
const GenericContentCarouselStyles = {
    CarouselWrapper,
    Container,
    Item,
    Title,
    Track,
};
export default GenericContentCarouselStyles;
